
'use strict'

export const ROOT_VALUE = 15 // flexible设定的根元素大小

export const BASE_BOX_SIZE = 160 // 预警页面div.plot的offsetWidth + margin-right

export const BASE_MENU_MOVE_DISTANCE = BASE_BOX_SIZE / ROOT_VALUE // 预警页面基地菜单每次次移动距离

export const NOT_SATISFIED = 1 // 基地状态为正常

export const CLOSE_TO_SATISFY = 2 // 基地状态为接近中心病株

export const SATISFIED = 3 // 基地状态为达到中心病株

export const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000 // 一天的毫秒值



// WEBPACK FOOTER //
// ./src/constants/constants.js